export default __webpack_public_path__ + "static/media/mockup-image-04.15147e0c.jpg";